const positiveWeight = [1, -1, 1, 1, -1]

export function splitRandomSign(values) {
    const positiveData = [];
    const negativeData = [];

    values.forEach((val, index) => {
        val = Number(Number(val).toFixed(0))
        const isPositive = positiveWeight[index] > 0;
        const signedVal = isPositive ? val : -val;

        if (signedVal >= 0) {
            positiveData.push(signedVal);
            negativeData.push(0);
        } else {
            positiveData.push(0);
            negativeData.push(signedVal);
        }
    });

    return {positiveData, negativeData};
}
